import { popup } from '../../../../src/helpers';
import WindowEventMixin from '../../../mixins/WindowEventMixin';

export default {
    mixins: [WindowEventMixin],

    data() {
        return {
            connectionMixin: true
        };
    },

    methods: {
        /**
         * Show the connection window
         */
        showConnectionWindow(url, callback = null) {
            const p = popup(url, 500, 600);

            const i = setInterval(() => {
                if (p.closed) {
                    this.$emit('load-contact');
                    if (callback) {
                        callback();
                    }
                    clearInterval(i);
                }
            }, 200);

            this.listenForMessages();
        },

        /**
         * Listen for cross-window messages
         */
        listenForMessages() {
            this.listenForWindowMessage('network-error', (event) => {
                this.$router.push({
                    name: 'v2.activation.brief.networks.failed',
                    params: { network: event.data.network }
                });
            });
        }
    }
};
